import { ID_TO_PAGE_MAP } from "../../app/Pages";
import { TPage } from "../../model";
import { PAGE_ID } from "../enum";

const getIdToPageMap = (pageId: PAGE_ID): React.FC<TPage> => ID_TO_PAGE_MAP[pageId];

export default getIdToPageMap;
